var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_2371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1022 16H4.89783C2.19759 16 0 13.8024 0 11.1022V4.89783C0 2.19759 2.19759 0 4.89783 0H11.1001C13.8003 0 15.9979 2.19759 15.9979 4.89783V11.1001C15.9979 13.8003 13.8003 15.9979 11.1001 15.9979L11.1022 16ZM4.89783 1.19849C2.85811 1.19849 1.19849 2.85811 1.19849 4.89783V11.1001C1.19849 13.1398 2.85811 14.8015 4.89991 14.8015H11.1022C13.1419 14.8015 14.8036 13.1419 14.8036 11.1001V4.89783C14.8036 2.85811 13.144 1.19642 11.1022 1.19642H4.89783V1.19849Z",
    fill: "#981BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99885 12.0473C5.76803 12.0473 3.95264 10.2319 3.95264 8.00105C3.95264 5.77023 5.76803 3.95483 7.99885 3.95483C10.2297 3.95483 12.0451 5.77023 12.0451 8.00105C12.0451 10.2319 10.2297 12.0473 7.99885 12.0473ZM7.99885 5.18033C6.44309 5.18033 5.17813 6.44529 5.17813 8.00105C5.17813 9.55681 6.44309 10.8218 7.99885 10.8218C9.55461 10.8218 10.8196 9.55681 10.8196 8.00105C10.8196 6.44529 9.55461 5.18033 7.99885 5.18033Z",
    fill: "#981BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5408 3.51239C13.5408 4.09398 13.0693 4.56548 12.4877 4.56548C11.9061 4.56548 11.4346 4.09398 11.4346 3.51239C11.4346 2.93079 11.9061 2.45929 12.4877 2.45929C13.0693 2.45929 13.5408 2.93079 13.5408 3.51239Z",
    fill: "#981BAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_2371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.dec808d3549acaf4c925b7938e55e63c.svg";
export { ForwardRef as ReactComponent };